/**
 * Refcounted body scroll lock so nested cart / dialog / footer overlays
 * cannot leave `overflow: hidden` stuck on document.body.
 */

let lockCount = 0;

function applyLock() {
  if (typeof document === 'undefined') return;
  document.body.style.overflow = 'hidden';
  document.body.classList.add('modal-open');
}

function clearLock() {
  if (typeof document === 'undefined') return;
  document.body.style.overflow = '';
  document.body.classList.remove('modal-open');
}

/** Acquire a scroll lock; call the returned function to release. */
export function acquireBodyScrollLock(): () => void {
  if (typeof document === 'undefined') {
    return () => undefined;
  }
  lockCount += 1;
  if (lockCount === 1) {
    applyLock();
  }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      clearLock();
    }
  };
}
